import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavScroll = (section) => {
    if (location.pathname === "/") {
      // Already on home, scroll
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Nishjesh Sports AI</h3>
            <p>
              {" "}
              Nishjesh Sport AI is an AI powered coaching platform for Badminton
              players.{" "}
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/policy">Policy</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>info@nishjeshsports-ai.com</p>
            <p>Phone: +1 909-235-9247</p>
            {/* <p>201 E Center St Suite 112, Anaheim CA 92805</p> */}
            <a
              // href="javascript:void(0)"
              // target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-link"
            >
              <FontAwesomeIcon icon={faWhatsapp} size="2x" /> Chat on WhatsApp
            </a>
          </div>

          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a
                // href="javascript:void(0)"
                // target="_blank"
                rel="noopener noreferrer"
                className="social-icon whatsapp"
              >
                <FontAwesomeIcon icon={faWhatsapp} size="2x" />
              </a>
              <a
                // href="javascript:void(0)"
                // target="_blank"
                rel="noopener noreferrer"
                className="social-icon youtube"
              >
                <FontAwesomeIcon icon={faYoutube} size="2x" />
              </a>
              <a
                // href="javascript:void(0)"
                // target="_blank"
                rel="noopener noreferrer"
                className="social-icon twitter"
              >
                <FontAwesomeIcon icon={faTwitter} size="2x" />
              </a>
              <a
                // href="javascript:void(0)"
                // target="_blank"
                rel="noopener noreferrer"
                className="social-icon instagram"
              >
                <FontAwesomeIcon icon={faInstagram} size="2x" />
              </a>
              <a
                // href="javascript:void(0)"
                // target="_blank"
                rel="noopener noreferrer"
                className="social-icon linkedin"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Nishjesh Sports AI. All rights
            reserved.
          </p>
          {/* <div className="footer-bottom-links">
            <Link to="/#features" onClick={(e) => { e.preventDefault(); handleNavScroll('features'); }}>Features</Link>
            <Link to="/#pricing" onClick={(e) => { e.preventDefault(); handleNavScroll('pricing'); }}>Pricing</Link>
            <Link to="/#faq" onClick={(e) => { e.preventDefault(); handleNavScroll('faq'); }}>FAQ</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
